import React, { useState } from 'react';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import InputBoxLarge from '../../../components/common/InputBox/InputBoxLarge';
import TextBox from '../../../components/common/TextBox/TextBox';
import ErrorNotification from '../../../components/common/AlertBox/ErrorNotification';
import { SuccessAlert } from '../../../components/common/AlertBox/GreenAlert';
import { useNavigate } from 'react-router-dom';
import '../../../components/common/CommonText.css';
import './PlanFeatures.css';
import { addFeature } from '../../../services/planfeatures/Featuresapi';

const FeaturesAdd = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({ name: '', description: '' });

    const handleChange = (key, value) => {
        setForm(prev => ({ ...prev, [key]: value }));
        setErrors(prev => { const e = { ...prev }; delete e[key]; return e; });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!form.name?.trim()) newErrors.name = ["Feature Name is required"];
        return newErrors;
    };

    const handleSubmit = async () => {
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) { setErrors(validationErrors); return; }

        const { success, data, message } = await addFeature(form);

        if (success) {
            SuccessAlert("Feature added successfully");
            navigate(`/features/detail/${data.id}`);
        } else {
            if (message && typeof message === 'object') {
                setErrors(message);
            } else {
                setErrors({ general: message || "Something went wrong" });
            }
        }
    };

    return (
        <div className="whole-container">
            <div className="top-heading">
                <PageHeader
                    pageName="Plans / Features /"
                    nestedpageName="Add Feature"
                    linkTo="/features"
                />
            </div>

            <div className="page-container">
                <ErrorNotification errors={errors} marginBottom="16px" />

                <div className="card">
                    <div className="card-header">
                        <span className="card-title">Add Feature</span>
                        <button
                            className="popup-add-button common-text white fts-15 ftw-5"
                            onClick={handleSubmit}
                        >
                            Add Feature
                        </button>
                    </div>

                    <div className="card-body">
                        <InputBoxLarge
                            label="Feature Name"
                            name="name"
                            defaultValue={form.name}
                            onChange={(e) => handleChange('name', e.target.value)}
                            isRequired
                            error={errors.name}
                        />
                        <TextBox
                            label="Description"
                            name="description"
                            defaultValue={form.description}
                            onChange={(e) => handleChange('description', e.target.value)}
                            error={errors.description}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeaturesAdd;